<template>
  <div v-loading="loading">
    <CheckFormBox :title="$t('message.DataRegistration.formData.owner_data')">
      <!-- 個人配額 -->
      <el-row v-if="applicantType === 'PERSON'" :gutter="48">
        <el-col :xs="24" :sm="24">
          <div class="form_label">{{ $t("message.spNo") }}：</div>
          <div class="form_value">{{ data.spNo }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Quota.idType") }}：
          </div>
          <div class="form_value">{{ data.quota.personIdentityType | vssTypesFilter(idTypes) }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Quota.personNameCn") }}：
          </div>
          <div class="form_value">{{ data.quota.personNameCn }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Quota.personNameEn") }}：
          </div>
          <div class="form_value">{{ data.quota.personNameEn }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Quota.personIdentityNo") }}：
          </div>
          <div class="form_value">{{ data.quota.personIdentityNo }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Vehicle.registrationNo") }}：
          </div>
          <div class="form_value">{{ data.vehicle.registrationNo }}</div>
        </el-col>
      </el-row>
      <!-- 公司配額 -->
      <el-row v-if="applicantType === 'COMPANY'" :gutter="48">
        <el-col :xs="24" :sm="24">
          <div class="form_label">{{ $t("message.spNo") }}</div>
          <div class="form_value">{{ data.spNo }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Quota.companyIdentityType") }}
          </div>
          <div class="form_value">{{ data.quota.companyIdentityType | companyType }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Quota.companyNameCn") }}
          </div>
          <div class="form_value">{{ data.quota.companyNameCn }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Quota.companyNameEn") }}
          </div>
          <div class="form_value">{{ data.quota.companyNameEn }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Quota.companyBrNo") }}
          </div>
          <div class="form_value">{{ data.quota.companyBrNo }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("message.DataRegistration.Vehicle.registrationNo") }}
          </div>
          <div class="form_value">{{ data.vehicle.registrationNo }}</div>
        </el-col>
      </el-row>
    </CheckFormBox>
    <div class="next_btn">
      <GradientBtn @click="next">{{
        $t("message.DataRegistration.International.next_pay")
      }}</GradientBtn>
    </div>
  </div>
</template>

<script>
import { applicantTypeFilter, companyType } from "@/filters";
import HzmbMoRenewApplicationAPI from "@/api/HzmbMoRenewApplicationAPI";
import CheckFormBox from "@/view/DataRegistration/Check/components/CheckFormBox.vue";
import GradientBtn from "@/components/GradientBtn.vue";
import VssViewAPI from '@/api/VssViewAPI';
export default {
  components: { CheckFormBox, GradientBtn },
  filters: { companyType },
  data() {
    return {
      businessType: this.$route.params.businessType,
      serviceType: this.$route.params.serviceType,
      applicationId: this.$route.params.applicationId,
      loading: false,
      verifyForm: {},
      data: { quota: {}, vehicle: {} },
      idTypes: [],
    };
  },
  computed: {
    applicantType() {
      return applicantTypeFilter(this.serviceType);
    },
  },
  methods: {
    // 下一步
    next() {
      this.$router.push(
        `/formdata/hzmb-mo-renew/payment/${this.businessType}/${this.serviceType}/${this.applicationId}`
      );
    },
    // 准入獲取資料
    async get() {
      this.loading = true;
      try {
        this.data = await HzmbMoRenewApplicationAPI.getById(this.applicationId);
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.idTypes = await VssViewAPI.getIdentityTypes();
  },
  created() {
    this.get();
  },
};
</script>

<style lang="scss" scoped>
/deep/.m-cell .m-cell-item .m-cell-item-title {
  width: 30%;
}
/deep/.m-cell .m-cell-item .m-cell-item-value {
  width: 40%;
}
</style>
